import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';
export const userSlice = createSlice({
  name: "user",
  initialState: {},
  reducers: {
    loadState: (state: any, action: any) => {
      state.value = action.payload;
    },
    loginLocalStorage: (state: any, action: any) => {
      state.value = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    loginCookies: (state: any, action: any) => {
      state.value = action.payload;
      Cookies.set('user', JSON.stringify(action.payload));
    },
    changeProfilePicture: (state: any, action: any) => {
      state.value = {
        ...state.value,
        profile_picture: action.payload
      };
    },
    updateProfile: (state: any, action: any) => {
      state.value = {
        ...state.value,
        ...action.payload
      }
    },
    deleteProfilePicture: (state: any, action: any) => {
      state.value.profile_picture = null;
    },
    isConnected: (state: any, action: any) => {
      state.value.connected = action.payload;
    },
    logout: (state: any) => {
      state.value = {};
      localStorage.removeItem("user");
      Cookies.remove('user');
      window.location.pathname = '/login';
    },
  },
});

export const {
  loadState,
  loginLocalStorage,
  loginCookies,
  logout,
  updateProfile,
  changeProfilePicture,
  deleteProfilePicture,
  isConnected
} = userSlice.actions;

export default userSlice.reducer;